@if (currentProjectName()) {
  <div class="user-roles-project-name">{{ currentProjectName() }}</div>
}
@if (userRoles()?.length || isTenantAdmin()) {
  <mat-expansion-panel class="user-roles-panel" togglePosition="before">
    <mat-expansion-panel-header>
      <mat-panel-title class="flex__justify-between margin-right-0">
        Roles
        <button mat-icon-button (click)="unhideAllRoles($event)">
          <mat-icon svgIcon="reset" size="20px" />
        </button>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="user-roles">
      @for (role of userRoles(); track role.roleName) {
        <div class="user-roles__row">
          @if (role.trimPackages || role.disciplines) {
            <button class="user-roles__expand" type="button" (click)="toggleExpanded(role.roleName)">
              <mat-icon size="m">{{
                expanded()[role.roleName || ''] ? 'expand_less' : 'expand_more'
              }}</mat-icon>
            </button>
          } @else {
            <span class="user-roles__expand-placeholder"></span>
          }

          <div class="user-roles__role">{{ role.roleName | rolePrettyPrint }}</div>

          <mat-slide-toggle [checked]="!role.hidden" (toggleChange)="toggleRole(role)"></mat-slide-toggle>
        </div>

        @if (expanded()[role.roleName || '']) {
          <div class="user-roles__children">
            @for (childValue of getChildValues(role); track childValue) {
              <div class="user-roles__child-row">
                <span class="user-roles__child-gutter"></span>
                <div class="user-roles__child">{{ childValue }}</div>
              </div>
            }
          </div>
        }
      }

      @if (isTenantAdmin()) {
        <div class="user-roles__row">
          <span class="user-roles__expand-placeholder"></span>
          <div class="user-roles__role">Tenant Admin</div>
          <mat-slide-toggle [checked]="true" disabled></mat-slide-toggle>
        </div>
      }
    </div>
  </mat-expansion-panel>
}
